export function parseFreeTextAnswer(s: string): number | undefined {
  const whitespaceCommaOrDot = /[\s,.]/g;
  const i1 = s.lastIndexOf(".");
  const i2 = s.lastIndexOf(",");
  if (i1 < 0 && i2 < 0) {
    const cleaned = s.replace(whitespaceCommaOrDot, "");
    const parsed = parseInt(cleaned, 10);
    return isNaN(parsed) ? undefined : parsed;
  } else if (i1 < i2) {
    const intPart = s.substring(0, i2).replace(whitespaceCommaOrDot, "");
    const decimalPart = s.substring(i2 + 1).replace(whitespaceCommaOrDot, "");
    const parsed = parseFloat(`${intPart}.${decimalPart}`);
    return isNaN(parsed) ? undefined : parsed;
  } else {
    const intPart = s.substring(0, i1).replace(whitespaceCommaOrDot, "");
    const decimalPart = s.substring(i1 + 1).replace(whitespaceCommaOrDot, "");
    const parsed = parseFloat(`${intPart}.${decimalPart}`);
    return isNaN(parsed) ? undefined : parsed;
  }
}
